// Deprecated so we don't need to update this list
export const ASSIGNEE_LIST = [
  'Andrew',
  'Avril',
  'Billy',
  'Camri',
  'Emely',
  'Ian',
  'Jameka',
  'Jannica',
  'Jehcel',
  'Jen',
  'John',
  'Kacey',
  'Kevin',
  'Kyle',
  'Latasha',
  'Michael',
  'Nicole',
  'Noemi',
  'Pete',
  'Phil',
  'Raquel',
]

export const ASSIGNEE_LIST_V2 = [
  '[ENR] Alexa',
  '[ENR] Anne',
  '[ENR] Chery',
  '[ENR] Darlyne',
  '[ENR] Drew',
  '[ENR] Editha',
  '[ENR] Gio',
  '[ENR] Gwen',
  '[ENR] Hannah',
  '[ENR] Jannica',
  '[ENR] Jasmine',
  '[ENR] Jehcel',
  '[ENR] Joanna',
  '[ENR] Johanna',
  '[ENR] JP',
  '[ENR] Kacey',
  '[ENR] Kelly',
  '[ENR] Kyle',
  '[ENR] Mark',
  '[ENR] Nikki',
  '[ENR] Raquel',
  '[ENR] Rio',
  '[ENR] Rosemarie',
  '[ENR] Sarrah',
  '[ENR] Val',
  '[CX] Alvaro',
  '[CX] Billy',
  '[CX] Emely',
  '[CX] Jameka',
  '[CX] Lily',
  '[CX] Melody',
  '[CX] Meredith',
  '[CX] Noemi',
  '[CX] Shalietha',
  '[CX] Shanneice',
  '[MGR] Kat',
  '[MGR] Kevin',
  '[MGR] Lori',
  '[MGR] Nicole',
  '[MGR] Paper Apps',
  '[PAY] Ace',
  '[PAY] Joric',
  '[PAY] Madz',
  '[PAY] Vic',
  '[QUO] Angelica',
  '[QUO] Bem',
  '[QUO] Clare',
  '[QUO] Cristina',
  '[QUO] Danica',
  '[QUO] Grace',
  '[QUO] Jayem',
  '[QUO] Klyde',
  '[QUO] Mike',
  '[QUO] Regie',
  '[QUO] Spike',
  '[QUO] Zen',
  '[RSD] Brian',
  '[RSD] Tara',
  '[RSD] Tash',
]

export const MANAGER_REVIEW = 'Manager Review'
export const DO_NOT_SUBMIT = 'Do not submit'
export const NEEDS_BINDER_PAYMENT = 'Needs Binder Payment'
export const NEEDS_QLE_DOCUMENTS = 'Needs QLE Documents'

export const SPECIAL_ASSIGNEE_LIST = [MANAGER_REVIEW, DO_NOT_SUBMIT]
